export default {
  title: "Night Elf",
  content: [
    "New ability: Elusiveness: Increases stealth level by 1 and movement speed while stealthed by 5%.",
    "Shadowmeld no longer increases stealth level.",
    "Quickness now also increase attack speed by 1%.",
  ],
};
